import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSports = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 25 25",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0)",
		children: /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M16.5,1.9c0,2.2-1.8,4-4,4s-4-1.8-4-4H6.3c-0.9,0-1.6,0.7-1.6,1.6V21c0,1.2,0.9,2.1,2.1,2.1 c0,0,0,0,0,0h11.3c1.2,0,2.1-0.9,2.1-2.1c0,0,0,0,0,0V3.5c0-0.9-0.7-1.6-1.6-1.6c0,0,0,0,0,0H16.5z"
			}),
			/* @__PURE__ */ _jsx("line", {
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				x1: 4.8,
				y1: 19.3,
				x2: 20.2,
				y2: 19.3
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M1,12.7h3.8V3L1,10V12.7z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M24,12.7h-3.8V3l3.8,7V12.7z"
			})
		] })
	})
});
export { SvgIconSports as ReactComponent };
